/* required data:
catalogQueryObject: object,
queryPending,
searchQuery,
catalogItems,
catalogPage,
catalogLastPage
 */

import { mapGetters } from "vuex";

import get from 'lodash/get';
import forEach from 'lodash/forEach';
import compact from 'lodash/compact';
import throttle from 'lodash/throttle'
import assign from 'lodash/assign'
import includes from 'lodash/includes'
import omit from 'lodash/omit'
import pick from 'lodash/pick'

import { parse, stringify } from 'qs';
import url from '@/filters/url';

const perPage = 100;
const defaultSortOrder = 'desc';

export const getCatalogQuery = ( query, stringifyFilter = false, nameProp = 'name' ) => {
    // Парсим query
    const {
        page,
        sort,
        order,
        filter
    } = parse(query)

    const name = parse(query)[nameProp]

    // Формируем ответ
    const searchQuery = name ? encodeURIComponent(decodeURIComponent(name)) : null
    const catalogPage = +page || 1
    const sortType = sort || null
    const sortOrder = order || null
    const filters = filter || null

    if (stringifyFilter) {
        forEach(filters, (param, key) => {
            if (Array.isArray(param)) {
                const values = compact(param)
                filters[key] = values.join(',')
            }
        })
    }

    return {
        filters,
        perPage,
        searchQuery,
        catalogPage,
        sortType,
        sortOrder
    };
};

const getFilterParams = filter => {
    const params = {}

    forEach(filter, (param, key) => {
        const arParam =
            includes(param, ',') ?
                compact(param.split(',')) :
                param

        params[key] = arParam;
    })

    return {filter: params};
}

export const getApiQueryParams = (query, filters = {}, nameProp = 'name') => {
    const catalogPage = parseInt(get(query, 'page', 1))
    const searchQuery = get(query, nameProp, undefined);
    const sortType = get(query, 'sort', undefined);
    const sortOrder = get(query, 'order', undefined);

    const result = {
        'per_page': perPage,
        page: catalogPage || undefined,
        sort: sortType,
        order: sortOrder,
    }

    result[nameProp] = searchQuery ? encodeURIComponent(decodeURIComponent(searchQuery)) : undefined;
    
    Object.keys(filters).forEach(key => {
        result[key] = filters[key]
    })

    return result
};

export const decadeDeclension = (value, forms) => {
    if (value.indexOf('s') > 0) {
        return parseInt(value) + ' ' + forms[1]
    }
    else {
        return value + ' ' + forms[0]
    }
}

export const CatalogListMixin = {
    data() {
        return {
            isSetQuery: true,
            nameProp: 'name',
            isSetFilters: true,
            itemsTotal: 0,
            singleButtonPagination: false,
            queryTimeout: null
        }
    },
    watch: {
        itemsTotal(value) {
            this.$emit('change-total', value)
        },
        sortOrder() {
            this.queryPending = true;
            const queryParams = {page: null, order: this.sortOrder};

            if (this.sortOptions && this.sortOrder === defaultSortOrder) {
                queryParams.order = null;
            }

            this.$url.modify(queryParams);
            this.setCatalogQuery(
                this.catalogQueryObject,
                this.searchQuery || null
            ).then((response) => this.requestDataAdapter(response))
        },

        sortType() {
            this.queryPending = true;
            const queryParams = {page: null, sort: this.sortType};

            if (this.sortOptions && this.sortType === Object.keys(this.sortOptions)[0]) {
                queryParams.sort = null;
            }
            this.$url.modify(queryParams);
            this.setCatalogQuery(
                this.catalogQueryObject,
                this.searchQuery || null
            ).then((response) => this.requestDataAdapter(response))
        },

        catalogPage(value) {
            if (this.queryPending === false) {
                const concatItemsMode = this.singleButtonPagination;
                if(this.singleButtonPagination === false) {
                    this.$scrollTo('.catalog-list', 950, {
                        offset: -130
                    })
                }

                this.queryPending = true;

                // if (!this.singleButtonPagination) {
                //     this.$url.modify({page: value});
                // }
                
                this.setCatalogQuery(
                    this.catalogQueryObject,
                    this.searchQuery || null,
                    value).then((response) => this.requestDataAdapter(response, concatItemsMode))
            }
        },

        searchQuery: throttle(function(value, prevValue) {
            if (value && value.length > 1) {
                this.queryPending = true;
                this.setCatalogQuery(this.catalogQueryObject, value)
                    .then((response) => {
                        this.requestDataAdapter(response);
                        this.totalItems = this.itemsTotal;
                    })
            }
            else if(prevValue && (prevValue.length <= 1 &&  prevValue.length > value.length)) {
                this.queryPending = true;
                this.setCatalogQuery(this.catalogQueryObject)
                    .then((response) => {
                        this.requestDataAdapter(response);
                        this.totalItems = this.itemsTotal;
                    })
            }
            else if(!value) {
                this.setCatalogQuery(this.catalogQueryObject)
                    .then((response) => {
                        this.requestDataAdapter(response);
                        this.totalItems = this.itemsTotal;
                    })
            }
        }, 1250),

        filters: throttle(function() {
            this.queryPending = true;
            this.setCatalogQuery(
                this.catalogQueryObject,
                this.searchQuery || null
            ).then((response) => this.requestDataAdapter(response))
        }, 1000)
    },
    computed: {
        ...mapGetters(['isDeviceDesktop', 'getNoImage', 'getEntityNoImage']),
        isFilterDisabled() {
            return !this.catalogItems || (this.catalogItems && !this.catalogItems.length)
        },
        filterOptions() {
            let currentOptions = {}

            if(!this.isDeviceDesktop) {
                currentOptions = {
                    loadedOverlay: true,
                    fullscreen: true,
                    draggable: false,
                    classes: 'modal__box_no_radius',
                    width: '100%',
                    height: '100%'
                }
            } else {
                currentOptions = {
                    loadedOverlay: false,
                    fullscreen: false,
                    draggable: false,
                    type: 'right',
                    classes: 'modal__box_no_radius',
                    width: '26%',
                    height: '100%'
                }
            }

            return currentOptions
        },
        pageHeadCounter(){
            const pageLocale = this.$i18n.locale === 'ru' ? 'Страница' : 'Page'
            return this.catalogPage > 1 ? ` - ${pageLocale} ${this.catalogPage}`  : ''
        }
    },
    mounted(){
        window.addEventListener('popstate', this.onPopState);
    },
    beforeDestroy(){
        window.removeEventListener('popstate', this.onPopState);
    },
    methods: {
        onPopState(){
            window.location.reload();
        },
        getParsedFilters() {
            const filter = get(this.$route.query, 'filter')
            return filter ? stringify(filter) : null
        },
        showFilter(name = 'catalog-filter') {
            this.$modal.show(
                name,
                this.filterParams,
                this.filterOptions
            )
        },
        onChangeSortType(value) {
            this.sortType = value
        },
        onChangeSortOrder(value) {
            this.sortOrder = value
        },
        onFilterSubmit($event) {
            this.filterIsShowed = false;
            this.filters = url.restQueryObject($event.values);
            this.filterParams = this.filters;
            this.queryPending = true;
            this.setCatalogQuery(this.catalogQueryObject, this.searchQuery)
                .then((response) => {
                    this.requestDataAdapter(response);
                    this.totalItems = this.itemsTotal;
                });
        },
        onFilterReset() {
        },
        resetAll() {
            this.queryPending = true;
            this.searchQuery = null;
            this[this.nameProp || 'name'] = null;

            if (this.filters) {
                this.filters = this.staticFilters ? pick(this.filters, this.staticFilters) : {};
            }
            if (this.filterParams) {
                this.filterParams = this.staticFilters ? pick(this.filterParams, this.staticFilters) : {};
            }
            this.$refs.filter.resetAll();
        },
        requestDataAdapter(response, concatItems = false) {
            if (response) {
                if (concatItems) {
                    this.catalogItems = [ ...this.catalogItems, ...response.items];
                }
                else {
                    this.catalogItems = response.items;
                }
                this.catalogPage = parseInt(response.page);
                this.catalogLastPage = parseInt(response.lastPage);

                this.$bus.$emit('next-url-change', response.nextPageUrl)

                this.$nextTick( ()=> {
                    this.queryPending = false;
                })
            }
        },
        onSelectLetter(letter) {
            this.letter = letter.value;
            this.queryPending = true;

            const params = {
                sort: this.sortType,
                order: this.sortOrder,
                page: null
            };

            if (params.sort === Object.keys(this.sortOptions)[0]) {
                delete params.sort;
            }

            if (!params.sort && params.order === (this.defaultSortOrder || 'desc')) {
                delete params.order;
            }

            if(letter.url)
                this.$url.set(url.modify(url.relative(letter.url), params));

            this.setCatalogQuery(this.catalogQueryObject, null)
                .then((response) => {
                    this.requestDataAdapter(response);
                    this.totalItems = this.itemsTotal;
                });
        },
        async setCatalogQuery(catalogQueryObject, searchQuery = null, page = null) {
            this.$root.$loading.start();

            if (this.queryTimeout) {
                return;
            }

            this.queryTimeout = true;
            const sort = this.sortType || undefined;
            const order = this.sortOrder || defaultSortOrder;
            const filters = url.restQueryObject(this.filters);

            const params = {
                'per_page': this.catalogItemsPerPage || perPage,
                page: page || null,
                sort: sort || undefined,
                order: order || undefined,
                ...filters
            };

            if (this.letter) {
                params.letter = this.letter;
            }

            params[this.nameProp] = searchQuery ? encodeURIComponent(decodeURIComponent(searchQuery)) : undefined;

            const result = await catalogQueryObject.params(params).get()

            const items = get(result, '[0].items', []);
            const currentPage = get(result, '[0].currentPage', 1);
            const lastPage = get(result, '[0].lastPage', 1);
            const nextPageUrl = get(result, '[0].nextPageUrl', null)

            this.itemsTotal = get(result, '[0].total', 0)
            
            const query = this.isSetFilters ? {} : this.$route.query
            const filter = this.isSetFilters ? this.filters : {}
            const filterParams = getFilterParams(filter);

            if (this.staticFilters && filterParams.filter) {
                filterParams.filter = omit(filterParams.filter, this.staticFilters);
            }
            

            const queryParams = {
                ...(this.singleButtonPagination === false) && {
                    page: page > 1 ? page + '' : null
                },
                sort: sort || undefined,
                order: order || undefined,
                ...filterParams
            }

            if (this.sortOptions && queryParams.sort === Object.keys(this.sortOptions)[0]) {
                queryParams.sort = null;
            }

            if (!queryParams.sort && queryParams.order === (this.defaultSortOrder || defaultSortOrder)) {
                queryParams.order = null;
            }

            queryParams[this.nameProp] = searchQuery || undefined
            const newQuery = assign(
                {},
                query,
                queryParams
            )

            if (this.isSetQuery) {
                this.$url.modify(newQuery);
            }

            this.$root.$loading.finish();
            this.queryTimeout = false;

            return {
                items,
                page: currentPage,
                lastPage,
                nextPageUrl
            }
        },
        getPerfumesDeclension(withNumber) {
            let text = this.$options.filters.numberDeclension(
                this.perfumesCount, 
                this.$t('declensions.perfumes'), 
                withNumber
            );

            if (this.q || this.searchQuery || Object.keys(this.filterParams).length > 1) {
                text += ' ' + this.$t('by_filter');
            };

            return text;
        },
        metaNextPage(){
            let url = this.$i18n.__baseUrl

            if(this.catalogPage === 1){
                url += this.$route.path + 'page/' + this.nextPage + '/'
            }else{
                url += this.$route.path.replace(/\/page\/[0-9]+/, '/page/' + this.nextPage)
            }

            return url
        },
        metaPrevPage(){
            let url = this.$i18n.__baseUrl

            if(this.catalogPage === 2){
                url += this.$route.path.replace(/\/page\/[0-9]+/, '')
            }else{
                url += this.$route.path.replace(/\/page\/[0-9]+/, '/page/' + this.prevPage)
            }

            return url
        },
        metaCanonical(){
            return this.$i18n.__baseUrl + this.$route.path.replace(/\/page\/[0-9]+/, '')
        }
    },
    head() {
        const meta = {
            title: get(this.meta, 'title', this.metaDefault.title) + this.pageHeadCounter,
            meta: this.$options.filters.metaApiExtract({meta: this.meta}, this.metaDefault),
            link: []
        }

        if (this.catalogPage > 1) {
            meta.link.push({
                hid: 'i18n-can',
                rel: 'canonical',
                href: get(this.meta, 'canonical', this.metaCanonical())
            });
        }

        if (this.catalogPage > 1 || this.letter)
            meta.meta.push({
                hid: 'robots',
                name: 'robots',
                content: 'noindex, follow'
            })

        if(!this.filtersCount){

            if(this.nextPage)
                meta.link.push(
                    {
                        rel: 'next',
                        href: this.metaNextPage()
                    }
                )

            if(this.prevPage)
                meta.link.push(
                    {
                        rel: 'prev',
                        href: this.metaPrevPage()
                    }
                )
        }

        return meta
    }
}
